import { render } from "./MailRequestForm.vue?vue&type=template&id=62015787"
import script from "./MailRequestForm.vue?vue&type=script&lang=js"
export * from "./MailRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__